export class ApiError extends Error {
  readonly code;
  constructor(code: ErrorCode, message: string) {
    super(message);
    this.code = code;
  }
}

export enum ErrorCode {
  InternalError = 0,

  BadRequest = 4000000,
  LotMaterialOverFlow,
  CarryInMaterialOverFlow,
  DuplicatedLoginID,
  DuplicatedGroupName,
  InvalidPayload,

  Unauthorized = 4010000,
  ApiAuthTokenNotFound,
  InvalidApiAuthToken,
  InvalidToken,

  Forbidden = 4030000,
  NoPermission,

  NotFound = 4040000,
  ApiNotFound,
  AccountNotFound,
  AccountGroupNotFound,
  GroupNotFound,
  UserNotFound,
  LotNotFound,
  CarryInNotFound,
  CarryOutNotFound,
  ConstructionPlanNotFound,
  ConstructionWorkNotFound,
  IssuanceNotFound,
  ConstructionPlanAreaNotFound,
  ConstructionNotFound,
  MaterialNotFound,

  Conflict = 4090000,
  DuplicatedEntry,
  // マスターCSV取り込みが他の利用者の書き込みとぶつかった状態。時間をおいて試せば解決しうる
  MasterImportConflict,

  InternalServerError = 5000000,
  Unknown,

  ServerError = 999,
}